var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalComponent',{attrs:{"width":750 - 128,"name":"modalSequenceNew"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var close = ref.close;
return [_c('SequenceNewComponent',{on:{"create":function($event){return _vm.handleCreate(close)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }